export function addComma(num) {
  return num?.toLocaleString();
}
